<template>
  <b-card
    class="collapsed-setting-card mb-0"
    :class="`collapsed-setting-card-${size}`"
    body-class="p-0 box-shadow-0 collapsed-setting"
  >
    <div
      class="collapsed-setting-header"
      :class="{'border-0': !showOptions}"
    >
      <div class="collapsed-setting-title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <slot name="caret">
        <b-button
          variant="transparent"
          class="btn-icon collapsed-setting-card-caret"
          size="lg"
          @click="triggerCollapse"
        >
          <feather-icon
            size="16"
            class="text-secondary"
            :icon="showOptions ? 'ChevronUpIcon' : 'ChevronDownIcon'"
          />
        </b-button>
      </slot>
    </div>
    <slide-y-up-transition>
      <div v-show="showOptions">
        <div class="collapsed-setting-body">
          <slot />
        </div>
        <div
          class="collapsed-setting-footer"
          :class="footerClass"
        >
          <slot name="footer" />
        </div>
      </div>
    </slide-y-up-transition>
  </b-card>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'

export default {
  name: 'CollapsedSettingCard',
  components: {
    BButton, BCard,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    footerClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    showOptions: {
      get() { return !this.collapsed },
      set(value) { this.$emit('update:collapsed', !value) },
    },
  },
  methods: {
    triggerCollapse() {
      const newValue = !this.showOptions
      this.$emit(this.showOptions ? 'closed' : 'opened')
      this.showOptions = newValue
    },
  },
}
</script>

<style lang="scss">

.collapsed-setting-card {
  margin-top: 29px;
}

.collapsed-setting {
  border-radius: 6px;
  border: solid 1px var(--purple);

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    color: var(--purple);
    padding: 18px 0 17px;
    margin: 0 30px;
    border-bottom: 1px solid var(--seperator-color);

    .collapsed-setting-card-sm & {
//      padding: 0 0 15px;
    }
  }

  &-body {
    padding: 16.5px 0;
  }
}
</style>
